import _ from 'lodash';
import { useSearchParams } from "react-router-dom";
import { SEARCHSTATE } from '../constants';

export const useSearchState = (str: string) => {
    const [param] = useSearchParams();
    return _.isEqual(param.get(SEARCHSTATE), str);
}
